import { render } from "./InfoStudyWord.vue?vue&type=template&id=8ecc364e&scoped=true"
const script = {}

import "./InfoStudyWord.vue?vue&type=style&index=0&id=8ecc364e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ecc364e"]])

export default __exports__